import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {forkJoin, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class TypesService {
  private handleError: HandleError;
  private loadedTypes = {};


  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('TypesService');
  }

  // get a list of originators and brokers
  getTypesList(name: string, sort = '', sd = 1): Promise<any> {
    let isPrivate = true;
    const publicTypes = ['feature-switches'];
    if (publicTypes.includes(name)) {
      isPrivate = false;
    }

    if (!this.loadedTypes[name]) {
      // TO DO: handle pagination
      let opts = '';
      if (sort) {
        opts = `?sort=${sort}&sd=${sd}`;
      }

      return this.http.get<any[]>(isPrivate ? `${environment.api.types}/list/${name}${opts}` : `${environment.api.submission}/${name}${opts}`, httpOptions)
        .pipe(
          map((val) => {
            this.loadedTypes[name] = val;
            return val;
          }),
          catchError(this.handleError('getTypesList', []))
        )
        .toPromise();
    }
    return Promise.resolve(this.loadedTypes[name]);
  }

  getTypes(types: Array<string>): Observable<any> {
    return forkJoin(types.map((type) => this.getTypesList(type, '', 1)));
  }
}
